import * as Select from '@radix-ui/react-select';
import { Check, ChevronDown } from 'lucide-react';

export function SingleSelect({ label, options, value, onChange, allLabel = 'All', allValue = 'ALL' }) {
  return <Select.Root value={value} onValueChange={onChange}>
    <Select.Trigger className="shadcn-select-trigger" aria-label={label}><Select.Value /><Select.Icon><ChevronDown size={14} /></Select.Icon></Select.Trigger>
    <Select.Portal><Select.Content className="shadcn-select-content" position="popper" sideOffset={5}>
      <Select.Viewport><Select.Item className="shadcn-select-item" value={allValue}><Select.ItemIndicator className="shadcn-select-check"><Check size={13} /></Select.ItemIndicator><Select.ItemText>{allLabel}</Select.ItemText></Select.Item>
        {options.map(option => <Select.Item className="shadcn-select-item" value={option} key={option}><Select.ItemIndicator className="shadcn-select-check"><Check size={13} /></Select.ItemIndicator><Select.ItemText>{option}</Select.ItemText></Select.Item>)}
      </Select.Viewport>
    </Select.Content></Select.Portal>
  </Select.Root>;
}
